import { SOCIAL_BUTTON_PROVIDERS } from 'js/src/components/auth/common/SocialButton';

export const GOOGLE_ONE_TAP = 'google-onetap';

export type LoginMethod = SOCIAL_BUTTON_PROVIDERS | 'email' | typeof GOOGLE_ONE_TAP;

const STORAGE_KEY = 'lumen5_last_login_method';

export const getLastLoginMethod = (): LoginMethod | null => {
    try {
        const value = localStorage.getItem(STORAGE_KEY);
        if (
            value === SOCIAL_BUTTON_PROVIDERS.GOOGLE ||
            value === SOCIAL_BUTTON_PROVIDERS.FACEBOOK ||
            value === SOCIAL_BUTTON_PROVIDERS.SSO ||
            value === 'email' ||
            value === GOOGLE_ONE_TAP
        ) {
            return value;
        }
        return null;
    } catch {
        return null;
    }
};

export const setLastLoginMethod = (method: LoginMethod): void => {
    try {
        localStorage.setItem(STORAGE_KEY, method);
    } catch {
        // localStorage unavailable
    }
};
